import React, { useState } from "react";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./Specials.css";

const Specials = () => {
  const [activeFilter, setActiveFilter] = useState("all");

  const deals = [
    { id: 1, name: "Handwoven Jamdani Saree", category: "fashion", originalPrice: 4500, salePrice: 3150, discount: 30, tag: "Flash Sale", image: null },
    { id: 2, name: "Organic Sylhet Tea 500g", category: "food", originalPrice: 850, salePrice: 595, discount: 30, tag: "Best Seller", image: null },
    { id: 3, name: "Nakshi Kantha Quilt", category: "handicrafts", originalPrice: 2800, salePrice: 1960, discount: 30, tag: "Limited", image: null },
    { id: 4, name: "Brass Decorative Bowl", category: "handicrafts", originalPrice: 1200, salePrice: 840, discount: 30, tag: "New", image: null },
    { id: 5, name: "Hilsa Fish Pickle 250g", category: "food", originalPrice: 650, salePrice: 455, discount: 30, tag: "Popular", image: null },
    { id: 6, name: "Muslin Cotton Kurta", category: "fashion", originalPrice: 1800, salePrice: 1260, discount: 30, tag: "Trending", image: null },
  ];

  const filters = ["all", "fashion", "food", "handicrafts"];

  const filtered = activeFilter === "all" ? deals : deals.filter(d => d.category === activeFilter);

  return (
    <div>
      <CartBannerComponent title="Specials" />
      <div className="container specials-container my-5">

        <div className="row mb-4">
          <div className="col-12 text-center">
            <h2 className="section-title">Special Offers & Deals</h2>
            <p className="text-muted">Exclusive discounts on authentic Bangladeshi products — for a limited time only.</p>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12 d-flex justify-content-center flex-wrap gap-2">
            {filters.map(f => (
              <button
                key={f}
                className={`filter-btn mr-2 mb-2 ${activeFilter === f ? "active" : ""}`}
                onClick={() => setActiveFilter(f)}
              >
                {f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="row">
          {filtered.map(deal => (
            <div key={deal.id} className="col-lg-4 col-md-6 mb-4">
              <div className="deal-card h-100">
                <div className="deal-image-placeholder">
                  <span className="deal-tag">{deal.tag}</span>
                  <div className="deal-discount-badge">-{deal.discount}%</div>
                  <div className="placeholder-icon">
                    <i className="fa fa-tag fa-3x text-white" />
                  </div>
                </div>
                <div className="deal-body p-3">
                  <h6 className="deal-name font-weight-bold">{deal.name}</h6>
                  <div className="deal-pricing d-flex align-items-center mt-2">
                    <span className="sale-price mr-2">৳{deal.salePrice.toLocaleString()}</span>
                    <span className="original-price text-muted"><del>৳{deal.originalPrice.toLocaleString()}</del></span>
                  </div>
                  <button className="btn btn-primary btn-sm mt-3 w-100">Add to Cart</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-5">
            <i className="fa fa-tag fa-3x text-muted mb-3" />
            <h5>No deals in this category right now.</h5>
            <p className="text-muted">Check back soon for more specials!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Specials;